export default "__VITE_ASSET__C3O3LCsB__"